import React, { Component, Children } from 'react';
import { Formik, yupToFormErrors } from 'formik';
import { Wrapper, FormElement } from './style';

const WizardPage = ({ children, values, ...rest }) => {
  const cx = Children.map(children, (child, index) => {
    const el = React.cloneElement(child, { values, ...rest });
    return el;
  });

  return cx;
};

// TODO: read on component composition patterns
// for an elegant api here.
// how to pass those values down?
class FormWizard extends Component {
  static FormWizardPage = WizardPage;

  constructor(props) {
    super(props);

    this.state = {
      page: 0,
      values: props.initialValues,
    };
  }

  previous = () => {
    this.setState(state => ({
      page: Math.max(state.page - 1, 0),
    }));
  };

  next = values => {
    const { page } = this.state;
    const { children } = this.props;
    const count = Children.count(children);
    const nextPage = Math.min(page + 1, count);

    this.setState(({ page, values }) => ({
      page: nextPage,
      values,
    }));
  };

  validate = values => {
    const activePage = React.Children.toArray(this.props.children)[
      this.state.page
    ];

    return new Promise((resolve, reject) => {
      const validations = activePage.props.validate
        ? activePage.props.validate(values)
        : Promise.resolve({});

      validations.then(resolve, err => {
        reject(yupToFormErrors(err));
      });
    });
  };

  handleSubmit = (values, bag) => {
    const { children, onSubmit } = this.props;
    const { page } = this.state;
    const isLastPage = page === Children.count(children) - 1;

    if (isLastPage) {
      return onSubmit(values);
    } else {
      this.next(values);
      bag.setSubmitting(false);
    }
  };

  render() {
    const { page, values } = this.state;
    const { children } = this.props;
    const cx = Children.toArray(children);
    const activePage = cx[page];
    const isLastPage = page === cx.length - 1;
    return (
      <Formik
        initialValues={values}
        enableReinitialize={false}
        validate={this.validate}
        onSubmit={this.handleSubmit}
        render={({ values, errors, handleSubmit, isSubmitting }) => {
          return (
            <Wrapper>
              <FormElement onSubmit={handleSubmit}>
                {React.cloneElement(activePage, {
                  values,
                  errors,
                  page,
                  isLastPage,
                  isSubmitting,
                  previous: this.previous,
                })}
              </FormElement>
            </Wrapper>
          );
        }}
      />
    );
  }
}

export default FormWizard;



// WEBPACK FOOTER //
// ./src/components/formwizard/index.js